import { DatabaseCode, toDatabaseCode } from "./database-code";

export type SystemProcessArtifactType = DatabaseCode;

const inputFile: SystemProcessArtifactType = {
  code: "INPUT_FILE",
  displayValue: {
    id: "common.entity.systemprocessartifacttype.inputFile",
    defaultMessage: "Input File",
  },
};

const outputFile: SystemProcessArtifactType = {
  code: "OUTPUT_FILE",
  displayValue: {
    id: "common.entity.systemprocessartifacttype.outputFile",
    defaultMessage: "Output File",
  },
};

const requestFile: SystemProcessArtifactType = {
  code: "REQUEST_FILE",
  displayValue: {
    id: "common.entity.systemprocessartifacttype.requestFile",
    defaultMessage: "Request File",
  },
};

const responseFile: SystemProcessArtifactType = {
  code: "RESPONSE_FILE",
  displayValue: {
    id: "common.entity.systemprocessartifacttype.responseFile",
    defaultMessage: "Response File",
  },
};

const logFile: SystemProcessArtifactType = {
  code: "LOG_FILE",
  displayValue: {
    id: "common.entity.systemprocessartifacttype.logFile",
    defaultMessage: "Log File",
  },
};

const configFile: SystemProcessArtifactType = {
  code: "CONFIG_FILE",
  displayValue: {
    id: "common.entity.systemprocessartifacttype.configFile",
    defaultMessage: "Config File",
  },
};

const checkpointFile: SystemProcessArtifactType = {
  code: "CHECKPOINT_FILE",
  displayValue: {
    id: "common.entity.systemprocessartifacttype.checkpointFile",
    defaultMessage: "Checkpoint File",
  },
};

export const systemProcessArtifactType = {
  inputFile,
  outputFile,
  requestFile,
  responseFile,
  logFile,
  configFile,
  checkpointFile,
};

export const systemProcessArtifactTypes = Object.values(systemProcessArtifactType);

export const toSystemProcessArtifactType = (
  code: string
): SystemProcessArtifactType =>
  toDatabaseCode(code, systemProcessArtifactTypes);

export const toSystemProcessArtifactTypeSafely = (
  code: string | undefined
): SystemProcessArtifactType | undefined =>
  code ? toDatabaseCode(code, systemProcessArtifactTypes) : undefined;
